import { db } from '@/shared/firebase/firebase-init';
/* eslint-disable */
export default  {
  log(data, operation, databasePath, entityName) {
    const modelLog = {
      data: data,
      entityPath: databasePath,
      entityName: entityName,
      operation: operation,
      modified: data.modified
    }

    db.ref(`log`).child(`logs`).child(databasePath).push(data);
    db.ref(`userActivity`).child(data.modifiedBy.id).push(modelLog);
  }
};



// WEBPACK FOOTER //
// ./src/shared/entity-logger.js